<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5.333 5.143C5.333 4.512 5.847 4 6.481 4h11.574a6.33 6.33 0 014.465 1.841 6.271 6.271 0 011.85 4.445 6.271 6.271 0 01-1.937 4.53 6.89 6.89 0 012.216 1.478 6.841 6.841 0 012.017 4.849 6.841 6.841 0 01-2.017 4.849A6.905 6.905 0 0119.777 28H6.482a1.146 1.146 0 01-1.148-1.143V5.143zM7.629 16.57v9.143h12.148a4.603 4.603 0 003.248-1.339 4.56 4.56 0 000-6.465 4.603 4.603 0 00-3.247-1.339H7.629zm10.426-2.285H7.63v-8h10.426a4.03 4.03 0 012.842 1.171 3.99 3.99 0 010 5.657 4.028 4.028 0 01-2.842 1.172z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'editorTextBoldOutline'
}
</script>
